import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { GrUserNew } from "react-icons/gr";
import { MdOutlineReviews } from "react-icons/md";

const Reviews = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('customer');

  // Customer reviews
  const [reviews, setReviews] = useState([]);
  const [allReviews, setAllReviews] = useState([]);
  const [customerSearch, setCustomerSearch] = useState('');

  // Bakpoket reviews
  const [bakpoketReview, setBakpoketReview] = useState([]);
  const [bakpoketSearch, setBakpoketSearch] = useState('');

  // New users
  const [newUsers, setNewUsers] = useState([]);

  // Visitors
  const [totalVisitors, setTotalVisitors] = useState('')
  const [todayTotalVisitors, setTodayTotalVisitors] = useState('')

  // Fetch customer reviews
  useEffect(() => {
    axios.get("https://api.bakpoket.com/api/AToZ/get-all-reviews")
      .then((res) => {
        if (res.data && Array.isArray(res.data.reviews)) {
          setReviews(res.data.reviews);
          setAllReviews(res.data.reviews);
        } else {
          setReviews([]);
          setAllReviews([]);
        }
      })
      .catch(() => setReviews([]));
  }, []);

  // Fetch new users
  useEffect(() => {
    axios.get('https://api.bakpoket.com/api/UserDetail1/getPublicStats')
      .then(res => setNewUsers(res.data))
      .catch(() => { });
  }, []);

  // Fetch Bakpoket reviews
  useEffect(() => {
    axios.get('https://api.bakpoket.com/api/AToZ/get-merchant-ratings')
      .then(res => {
        if (Array.isArray(res.data)) setBakpoketReview(res.data);
      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    axios.get('https://api.bakpoket.com/api/Admin/visitors')
      .then(res => {
        console.log('visitors', res)
        if (res.data.length > 0) {
          setTotalVisitors(res.data.length)
          const today = new Date().toISOString().split('T')[0];
          console.log(today)

          const todayVisitors = res.data.filter(visitor =>
            // const visitordate = visitor.visitDate.toISOString().split('T')[0]
            // return visitordate==today
            visitor.visitDate.startsWith(today)
            // console.log(visitordate)

          );
          if(todayVisitors.length >0){
          setTodayTotalVisitors(todayVisitors.length)
          }else{
            setTodayTotalVisitors(0)
          }
        }else{
          setTotalVisitors(0)
          setTodayTotalVisitors(0)
        }
      }).catch(() => { });
  }, [])

  // Filter customer reviews
  useEffect(() => {
    const filtered = allReviews.filter(item =>
      item.couponName.toLowerCase().includes(customerSearch.trim().toLowerCase())
    );
    setReviews(filtered);
  }, [customerSearch, allReviews]);

  // Filter Bakpoket reviews
  const filteredBakpoketReviews = bakpoketReview.filter(item =>
    item.reviews[0].couponName.toLowerCase().includes(bakpoketSearch.trim().toLowerCase())
  );

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <>
      <button onClick={toggleModal} className='btn'>FIND YOUR BEST</button>

      {isOpen && (
        <ModalOverlay>
          <ModalContent>
            <CloseButton onClick={toggleModal}>&times;</CloseButton>

            <TabContainer>
              <TabButton $active={activeTab === 'customer'} onClick={() => setActiveTab('customer')}>
                <span className="tab-text">Customer Reviews</span>
                <span className="tab-icon"><MdOutlineReviews /></span>
              </TabButton>

              <TabButton $active={activeTab === 'bakpoket'} onClick={() => setActiveTab('bakpoket')}>
                <span className="tab-text">Bakpoket Reviews</span>
                <span className="tab-icon"><MdOutlineReviews /></span>
              </TabButton>

              {/* <TabButton $active={activeTab === 'newusers'} onClick={() => setActiveTab('newusers')}>
                <span className="tab-text">New Users</span>
                <span className="tab-icon"><GrUserNew /></span>
              </TabButton> */}
            </TabContainer>

            <ReviewSection>
              {activeTab === 'customer' && (
                <div>
                  <div className="text-center my-3">
                    <h5 className="review-title">Customer Reviews</h5>
                    <input
                      type="search"
                      className="customer-reviews-input form-control mx-auto"
                      placeholder="Search for reviews..."
                      value={customerSearch}
                      onChange={(e) => setCustomerSearch(e.target.value)}
                    />
                  </div>

                  {reviews.length === 0 ? <p>No reviews found.</p> :
                    <div className='ratings reviews-container'>
                      {reviews.map((review, index) => (
                        <div key={index} className='review-card p-3 mb-3 shadow-sm rounded border border-light'
                          style={{ background: 'linear-gradient(135deg, #f9f9f9, #ffffff)', transition: 'transform 0.2s', cursor: 'pointer' }}
                          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
                          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
                          <div className='d-flex justify-content-between align-items-center mb-2'>
                            <h6 className='mb-0'>{review.couponName}</h6>
                            <div className='stars' style={{ color: '#f5a623', fontSize: '1.1rem' }}>
                              {'★'.repeat(review.rating) + '☆'.repeat(5 - review.rating)}
                            </div>
                          </div>
                          <p className='mb-1 text-muted text-start'><strong>{review.userName}</strong>: {review.reviewText}</p>
                        </div>
                      ))}
                    </div>
                  }
                </div>
              )}

              {activeTab === 'bakpoket' && (
                <div>
                  <div className="text-center my-3">
                    <h5 className="review-title">Bakpoket Reviews</h5>
                    <input
                      type="search"
                      className="customer-reviews-input form-control mx-auto"
                      placeholder="Search for merchant..."
                      value={bakpoketSearch}
                      onChange={(e) => setBakpoketSearch(e.target.value)}
                    />
                  </div>

                  {filteredBakpoketReviews.length === 0 ? <p>No reviews found.</p> :
                    <div className='ratings reviews-container'>
                      {filteredBakpoketReviews.map((review, index) => (
                        <div key={index} className='review-card p-3 mb-3 shadow-sm rounded border border-light'
                          style={{ background: 'linear-gradient(135deg, #f9f9f9, #ffffff)', transition: 'transform 0.2s', cursor: 'pointer' }}
                          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
                          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
                          <div className='d-flex justify-content-between align-items-center mb-2'>
                            <h6 className='mb-0'>{review.reviews[0].couponName}</h6>
                            <div className='stars ' style={{ lineHeight: '1rem' }}>
                              <strong className='fs-5'>{review.averageRating} <span style={{ color: '#f5a623', fontSize: '1.1rem' }}>★</span></strong><br />
                              <small style={{ fontSize: '11px' }}>{review.totalReviews} Reviews</small>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  }
                </div>
              )}

              {activeTab === 'newusers' && (
                <div className='text-center newusers d-flex flex-column align-items-center justify-content-center'>
                  <h5>New User Info</h5>
                  <p>Registered Users: <span className='fw-bold'>{newUsers.registeredUsers || 0}</span></p>
                  <p>Daily Users: <span className='fw-bold'>{newUsers.registeredUsers - 12 > 0 ? newUsers.registeredUsers - 12 : 0}</span></p>
                </div>
              )}
            </ReviewSection>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default Reviews;


// Styled Components
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: grid;
  place-items: center;
  z-index: 999;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  border-radius: 16px;
  position: relative;
`;

export const CloseButton = styled.span`
  position: absolute;
  // right: 20px;
  // top: 10px;
  right: 14px;
  top: 0px;
  font-size: 24px;
  cursor: pointer;
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  gap: 10px;
`;

export const TabButton = styled.button`
  flex: 1;
  padding: 10px;
  font-size: 14px;
  border: none;
  background-color: ${({ $active }) => ($active ? '#ef4766' : '#e6e6e6')};
  color: ${({ $active }) => ($active ? 'white' : 'black')};
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  .tab-text { display: inline; }
  .tab-icon { display: none; font-size: 18px; }

  &:hover {
    background-color: #e74c69ff;
    color: white;
  }

  @media (max-width: 768px) {
    .tab-text { display: none; }
    .tab-icon { display: inline; }
  }
`;

export const ReviewSection = styled.div`
  .customer-reviews-input:focus {
    outline: none;
    box-shadow: none;
  }

  .ratings {
    overflow-y: auto;
    max-height: 150px;
  }

  h5 { margin-bottom: 10px; }
  p { font-size: 14px; margin-bottom: 8px; }

  .ratings::-webkit-scrollbar { width: 6px; }

  .review-title { font-weight: 600; margin-bottom: 10px; }

  .customer-reviews-input {
    max-width: 300px;
    padding: 8px 12px;
    border-radius: 6px;
    border: 1px solid #ccc;
    outline: none;
    transition: all 0.3s ease;
  }

  .customer-reviews-input:focus {
    border-color: #ccc;
    box-shadow: 0 0 4px #ccc;
  }

  .newusers { height: 242px; }
`;


